import React from 'react'

export const NoCargaModulo = () => {
    return(
        <div className='container mt-5' style={{minHeight:'100vh'}}>
            <div className="alert alert-danger text-center" role="alert">
                <h5> No Seleccionó un Módulo! </h5>
                Reinicie la sesión
            </div>
        </div>
    )
}
